/**
 * Paths canónicos indexables (sin query).
 */

export function storePath (clientCode) {
  if (!clientCode) return null
  return `/tienda/${encodeURIComponent(String(clientCode).trim())}`
}

export function productPath (clientCode, productId, mesaId = null) {
  if (!clientCode || productId == null || productId === '') return null
  const base = storePath(clientCode)
  if (!base) return null
  if (mesaId) {
    return `${base}/mesa/${encodeURIComponent(String(mesaId))}/productos/${encodeURIComponent(String(productId))}`
  }
  return `${base}/productos/${encodeURIComponent(String(productId))}`
}
